import BaseDataService from "./BaseDataService";

class APIDataService extends BaseDataService {
  constructor(name){
    super(name)
    this.moduleName = 'roles'
  }
}

export default new APIDataService();